import React from "react";
import { Button } from "@material-ui/core";
import { ReactRender } from "@/components/ReactRender";
import { useTranslation } from "../langs/useTranslation";
import DataTable from "@/components/DataTable";
import HasPermission from "@/components/commons/HasPermission";
import { formatDate } from "./datetimeHandlers";
import { Rule } from "./DeviceNamingDatatable";
import { OSTypeChip } from "@/components/FormFields/OSType";
import { DeviceNamingChipStatus } from "@/components/FormFields/DeviceNamingStatus";
import { getNamingList } from "@/apis/apiCollection";

export const CompanyDeviceNamingDatatable = React.forwardRef(
  (
    {
      className,
      style,
      footer,
      children,
      onCheckAll,
      onLoaded,
      onView,
      onEdit,
      onEnable,
      showFooter
    },
    ref
  ) => {
    const { t } = useTranslation();

    const columns = [
      {
        name: "orderNo",
        className: "left0",
        title: t({ defaultMessage: "序号" })
      },
      {
        data: "name",
        title: t({ defaultMessage: "命名规则名称" })
      },
      {
        data: "osType",
        title: t({ defaultMessage: "OS类型" }),
        createdCell: (td, data) => {
          ReactRender(<OSTypeChip type={data} />, td);
        }
      },
      {
        data: "status",
        title: t({ defaultMessage: "状态" }),
        className: "center",
        createdCell: (td, data) => {
          ReactRender(<DeviceNamingChipStatus status={data} />, td);
        }
      },
      {
        data: "rules",
        title: t({ defaultMessage: "命名规则" }),
        createdCell: (td, data, row) => {
          ReactRender(<Rule rules={data} delimiter={row.delimiter} />, td);
        }
      },
      {
        data: "createdAt",
        title: t({ defaultMessage: "创建时间" }),
        render: data => {
          return formatDate(data);
        }
      },
      {
        data: "updatedAt",
        title: t({ defaultMessage: "更新时间" }),
        render: data => {
          return formatDate(data);
        }
      },
      {
        data: null,
        title: t({ defaultMessage: "操作" }),
        className: "center nowrap",
        width: 220,
        createdCell: (td, data, row) => {
          ReactRender(
            <>
              <Button size="small" color="primary" onClick={() => onView(row)}>
                {t({ defaultMessage: "查看" })}
              </Button>
              <HasPermission permission="device_naming_method_edit">
                <Button
                  size="small"
                  color="primary"
                  onClick={() => onEdit(row)}
                >
                  {t({ defaultMessage: "编辑" })}
                </Button>
              </HasPermission>
              <HasPermission permission="device_naming_method_enable_disable">
                {row.status === 0 ? (
                  <Button
                    size="small"
                    color="primary"
                    onClick={() => onEnable(row, false)}
                  >
                    {t({ defaultMessage: "禁用" })}
                  </Button>
                ) : (
                  <Button
                    size="small"
                    color="primary"
                    onClick={() => onEnable(row, true)}
                  >
                    {t({ defaultMessage: "启用" })}
                  </Button>
                )}
              </HasPermission>
            </>,
            td
          );
        }
      }
    ];

    const ajax = (data, callback) => {
      return getNamingList({
        ...data,
        status: -1,
        level: 0
      }).then(res => {
        callback({
          data: res.namingRules,
          draw: data.draw,
          recordsFiltered: res.total,
          recordsTotal: res.total
        });
      });
    };

    return (
      <DataTable
        ref={ref}
        ordering={false}
        paging={false}
        columns={columns}
        ajax={ajax}
        className={className}
        style={style}
        footer={footer}
        showFooter={showFooter}
        scrollable
        showCheckAll={false}
        onCheckAll={onCheckAll}
        onLoaded={onLoaded}
      >
        {children}
      </DataTable>
    );
  }
);
